import React from "react";
import {withStyles} from "@material-ui/core/styles";
import TreeItem from "@material-ui/lab/TreeItem";
import {
    TransitionComponent
} from "../../../../../ApplicationBuilder/ApplicationDesigner/ApplicationTree/Tree/TreeUtils";
import RenderComponents from "../../RenderComponents";

const StyledTreeItemVertical = withStyles((theme) => ({
    iconContainer: {
        '& .close': {
            opacity: 0.3,
        },
    },
    group: {
        marginLeft: 7,
        paddingLeft: 8,
        borderLeft: `1px dashed ${theme.palette.text.primary}`,
    },
}))((props) => {
    const {component, doc} = props;
    return (
        <TreeItem
            {...props}
            classes={{selected: props.classes.selected, root: props.classes.root, ...props.classes,}}
            nodeId={props.nodeId}
            onDoubleClick={(e) => {
                e.stopPropagation();
                props.onDoubleClick(doc)
            }}
            label={
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    {(component.children || []).map(element => {
                        return (
                            <RenderComponents
                                key={element.id}
                                element={element}
                                actionsContext={{doc}}
                            />
                        )
                    })}
                </div>}
            TransitionComponent={TransitionComponent}
        />
    )
});
export default StyledTreeItemVertical;
